import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const ListarPersonal = () => {
  const [personal, setPersonal] = useState([]);
  const [editando, setEditando] = useState(null);
  const [formData, setFormData] = useState({});
  const [orden, setOrden] = useState({ columna: null, ascendente: true });

  const obtenerPersonal = () => {
    axios.get('https://casinop2.sanjoseapps.cl/api/listar-personal.php')
      .then(res => setPersonal(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    obtenerPersonal();
  }, []);

  const handleDelete = (rut) => {
    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
      axios.post('https://casinop2.sanjoseapps.cl/api/eliminar-personal.php', { rut })
        .then(() => obtenerPersonal())
        .catch(err => console.error(err));
    }
  };

  const handleEdit = (persona) => {
    setEditando(persona.Rut);
    setFormData(persona);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = () => {
    axios.post('https://casinop2.sanjoseapps.cl/api/actualizar-personal.php', formData)
      .then(() => {
        setEditando(null);
        obtenerPersonal();
      })
      .catch(err => console.error(err));
  };

  const ordenarPor = (columna) => {
    const ascendente = orden.columna === columna ? !orden.ascendente : true;
    const datosOrdenados = [...personal].sort((a, b) => {
      if (a[columna] < b[columna]) return ascendente ? -1 : 1;
      if (a[columna] > b[columna]) return ascendente ? 1 : -1;
      return 0;
    });
    setPersonal(datosOrdenados);
    setOrden({ columna, ascendente });
  };

  const columnas = [
    { clave: 'Rut', titulo: 'RUT' },
    { clave: 'Nombre', titulo: 'Nombre' },
    { clave: 'CentroCosto', titulo: 'Centro Costo' },
    { clave: 'NombreEmpresa', titulo: 'Empresa' },
    { clave: 'AreaTrabajo', titulo: 'Área' },
    { clave: 'RutEmpresa', titulo: 'RUT Empresa' }
  ];

  return (
    <>
      <Navbar />
      <section className="section">
        <div className="container">
          <h1 className="title">Lista de Personal</h1>
          <table className="table is-fullwidth is-striped is-hoverable">
            <thead>
              <tr>
                {columnas.map(col => (
                  <th key={col.clave} onClick={() => ordenarPor(col.clave)} style={{ cursor: 'pointer' }}>
                    {col.titulo} {orden.columna === col.clave && (orden.ascendente ? '🔼' : '🔽')}
                  </th>
                ))}
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {personal.map((p) => (
                <tr key={p.Rut}>
                  {editando === p.Rut ? (
                    <>
                      {columnas.map(col => (
                        <td key={col.clave}>
                          <input className="input" name={col.clave} value={formData[col.clave]} onChange={handleChange} />
                        </td>
                      ))}
                      <td>
                        <button className="button is-success is-small" onClick={handleUpdate}>Guardar</button>
                      </td>
                    </>
                  ) : (
                    <>
                      {columnas.map(col => (
                        <td key={col.clave}>{p[col.clave]}</td>
                      ))}
                      <td>
                        <button className="button is-warning is-small mr-1" onClick={() => handleEdit(p)}>Editar</button>
                        <button className="button is-danger is-small" onClick={() => handleDelete(p.Rut)}>Eliminar</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default ListarPersonal;
